module.exports = __webpack_public_path__ + "static/media/icon-risk-management-white.1a302aee.svg";